import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api, { formatApiError } from "@/lib/api";
import { toast } from "sonner";
import * as Icons from "lucide-react";
import { StatusBadge } from "@/components/Layout";

function Icon({ name, className }) { const C = Icons[name] || Icons.Circle; return <C className={className} />; }

export function ComeFunziona() {
  const steps = [
    { i: "MousePointerClick", t: "1. Scegli il tuo settore", d: "9 attività reali con KPI e domande su misura. Nessun questionario generico." },
    { i: "PencilRuler", t: "2. Inserisci 4 dati chiave", d: "Fatturato, personale, costo merce, affitto. Nessun bilancio da caricare." },
    { i: "Sparkles", t: "3. Ricevi diagnosi e insight", d: "Score 0-100 e 3 insight prioritari in italiano semplice, subito azionabili." },
    { i: "TrendingUp", t: "4. Sblocca simulatori e piano d'azione", d: "What-If prezzi/costi, benchmark, business plan e AI Advisor (in arrivo)." },
  ];
  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
      <h1 className="text-4xl sm:text-5xl font-extrabold tracking-tight max-w-3xl">Come funziona ImpresaChiara</h1>
      <p className="mt-4 text-lg text-[#524F5E] max-w-2xl">Dai numeri al piano d'azione in quattro passi semplici. Senza commercialisti al telefono, senza fogli Excel infiniti.</p>
      <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-5 mt-12">
        {steps.map((s,i) => (
          <div key={i} className="ic-card p-6" data-testid={`step-${i+1}`}>
            <div className="w-11 h-11 rounded-xl bg-[#5424D5] text-white flex items-center justify-center mb-4"><Icon name={s.i} className="w-5 h-5"/></div>
            <h3 className="font-semibold text-lg">{s.t}</h3>
            <p className="text-sm text-[#524F5E] mt-2">{s.d}</p>
          </div>
        ))}
      </div>
      <div className="mt-16 ic-card p-10 bg-[#171522] text-white flex flex-wrap justify-between items-center gap-4">
        <div><h3 className="text-2xl font-bold">Pronto a iniziare?</h3><p className="text-white/70">Il Business Check è gratuito. Ci vogliono 3 minuti.</p></div>
        <Link to="/business-check" className="ic-btn-accent">Fai ora il Business Check</Link>
      </div>
    </div>
  );
}

export function Servizi() {
  const [svcs, setSvcs] = useState([]);
  useEffect(() => { api.get("/services").then(r => setSvcs(r.data)); }, []);
  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
      <h1 className="text-4xl sm:text-5xl font-extrabold tracking-tight">Servizi & Strumenti</h1>
      <p className="mt-4 text-lg text-[#524F5E] max-w-2xl">L'ecosistema modulare ImpresaChiara: strumenti attivi oggi e in arrivo nei prossimi mesi.</p>
      <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-5 mt-10">
        {svcs.map(s => (
          <div key={s.service_id} className="ic-card p-6" data-testid={`service-${s.service_id}`}>
            <div className="flex items-start justify-between mb-3">
              <div className="w-11 h-11 rounded-xl bg-[#EDE8FC] text-[#5424D5] flex items-center justify-center"><Icon name={s.icon} className="w-5 h-5"/></div>
              <StatusBadge status={s.status} />
            </div>
            <h3 className="font-semibold text-lg">{s.service_name}</h3>
            <p className="text-sm text-[#524F5E] mt-1">{s.description}</p>
            <Link to={`/${s.slug}`} className="text-sm text-[#5424D5] font-semibold inline-block mt-4">Approfondisci →</Link>
          </div>
        ))}
      </div>
    </div>
  );
}

export function ComingSoonPage({ title, subtitle, service }) {
  const [f, setF] = useState({ email: "", name: "", city: "" });
  const [sent, setSent] = useState(false);
  const submit = async (e) => {
    e.preventDefault();
    try { await api.post("/waitlist", { ...f, service }); setSent(true); toast.success("Sei in lista d'attesa!"); }
    catch (e) { toast.error(formatApiError(e)); }
  };
  return (
    <div className="max-w-4xl mx-auto px-4 py-16">
      <span className="ic-badge status-coming mb-4"><span className="w-1.5 h-1.5 rounded-full bg-[#FF6A24]" />Coming Soon</span>
      <h1 className="text-4xl sm:text-5xl font-extrabold tracking-tight">{title}</h1>
      <p className="mt-4 text-lg text-[#524F5E] max-w-2xl">{subtitle}</p>
      <div className="ic-card p-8 mt-10 max-w-xl">
        {sent ? (
          <div className="text-center">
            <Icons.CheckCircle2 className="w-12 h-12 text-[#10B981] mx-auto" />
            <h3 className="mt-4 font-bold text-lg">Sei in lista d'attesa!</h3>
            <p className="text-[#524F5E]">Ti scriveremo appena {title} sarà disponibile.</p>
          </div>
        ) : (
          <form onSubmit={submit} className="space-y-3">
            <h3 className="font-semibold">Ricevi accesso in anteprima + 1 mese CONTROL gratis</h3>
            <input required placeholder="Nome" value={f.name} onChange={e => setF({...f, name: e.target.value})} className="w-full px-4 py-3 rounded-xl border border-[#E5E4EB]" data-testid="waitlist-name" />
            <input required type="email" placeholder="Email" value={f.email} onChange={e => setF({...f, email: e.target.value})} className="w-full px-4 py-3 rounded-xl border border-[#E5E4EB]" data-testid="waitlist-email" />
            <input placeholder="Città" value={f.city} onChange={e => setF({...f, city: e.target.value})} className="w-full px-4 py-3 rounded-xl border border-[#E5E4EB]" data-testid="waitlist-city" />
            <button type="submit" className="w-full ic-btn-primary" data-testid="waitlist-submit">Entra in lista d'attesa</button>
          </form>
        )}
      </div>
    </div>
  );
}


const LEGAL_NOTE = "Documento in revisione legale (LEGAL_REVIEW_REQUIRED). Versione bozza v0.9 del 10/09/2026 — non costituisce validazione legale definitiva.";

function LegalShell({ title, children, testid }) {
  return (
    <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-16" data-testid={testid}>
      <h1 className="text-3xl sm:text-4xl font-extrabold tracking-tight">{title}</h1>
      <p className="text-xs text-[#C2410C] bg-[#FFF0E8] border border-[#FF6A24]/40 rounded-lg p-3 mt-4">{LEGAL_NOTE}</p>
      <div className="mt-8 space-y-6 text-sm text-[#524F5E] leading-relaxed">{children}</div>
    </div>
  );
}

export function PrivacyPage() {
  return (
    <LegalShell title="Privacy Policy" testid="privacy-page">
      <section><h2 className="font-bold text-[#171522] text-lg">1. Titolare del trattamento</h2><p>ImpresaChiara — [dati societari in revisione legale]. Contatto privacy: hello@impresachiara.it.</p></section>
      <section><h2 className="font-bold text-[#171522] text-lg">2. Dati raccolti</h2><p>Dati di account (nome, email), dati aziendali inseriti volontariamente (fatturato, costi, KPI), dati tecnici di sessione. Non raccogliamo dati sensibili.</p></section>
      <section><h2 className="font-bold text-[#171522] text-lg">3. Finalità e base giuridica</h2><p>Erogazione del servizio di analisi finanziaria (esecuzione contratto), miglioramento del prodotto in forma aggregata e anonima (legittimo interesse), adempimenti fiscali sui pagamenti (obbligo legale).</p></section>
      <section><h2 className="font-bold text-[#171522] text-lg">4. Conservazione</h2><p>I dati sono conservati fino a cancellazione dell'account. La cancellazione elimina account, dati aziendali, KPI, obiettivi e storici associati. [Retention policy dettagliata in revisione legale.]</p></section>
      <section><h2 className="font-bold text-[#171522] text-lg">5. Diritti GDPR</h2><p>Accesso, rettifica, cancellazione (disponibile in autonomia dalle impostazioni account), portabilità, opposizione. Scrivi a hello@impresachiara.it.</p></section>
      <section><h2 className="font-bold text-[#171522] text-lg">6. Terze parti</h2><p>Stripe (pagamenti, PCI-DSS), infrastruttura cloud EU. Nessuna vendita di dati a terzi.</p></section>
    </LegalShell>
  );
}

export function TerminiPage() {
  return (
    <LegalShell title="Termini di Servizio" testid="terms-page">
      <section><h2 className="font-bold text-[#171522] text-lg">1. Natura del servizio</h2><p>ImpresaChiara fornisce analisi finanziarie, score, benchmark e simulazioni a scopo informativo. I risultati sono stime basate sui dati inseriti e sui benchmark disponibili: non rappresentano risultati garantiti e non sostituiscono la consulenza di un commercialista o consulente finanziario.</p></section>
      <section><h2 className="font-bold text-[#171522] text-lg">2. Account e responsabilità</h2><p>L'utente è responsabile dell'accuratezza dei dati inseriti e della riservatezza delle credenziali. Un account può gestire le aziende previste dal piano.</p></section>
      <section><h2 className="font-bold text-[#171522] text-lg">3. Piani e pagamenti</h2><p>I prezzi pubblicati sono da intendersi + IVA. Gli abbonamenti si rinnovano automaticamente e possono essere disdetti in qualsiasi momento dal portale di fatturazione, con effetto a fine periodo.</p></section>
      <section><h2 className="font-bold text-[#171522] text-lg">4. Limitazione di responsabilità</h2><p>ImpresaChiara non risponde di decisioni imprenditoriali assunte sulla base delle stime fornite. [Testo definitivo in revisione legale.]</p></section>
      <section><h2 className="font-bold text-[#171522] text-lg">5. Accettazione</h2><p>La registrazione richiede accettazione esplicita e versionata dei presenti Termini (versione registrata in fase di signup).</p></section>
    </LegalShell>
  );
}

export function CookiePage() {
  return (
    <LegalShell title="Cookie Policy" testid="cookie-page">
      <section><h2 className="font-bold text-[#171522] text-lg">1. Cosa usiamo</h2><p>Solo cookie tecnici di sessione e autenticazione (necessari al funzionamento) e eventi analytics first-party anonimi. Nessun cookie di profilazione o tracciamento terze parti.</p></section>
      <section><h2 className="font-bold text-[#171522] text-lg">2. Consenso</h2><p>I cookie tecnici non richiedono consenso preventivo (art. 122 Codice Privacy). Se in futuro attiveremo tracker non tecnici, verrà mostrato un banner di consenso.</p></section>
      <section><h2 className="font-bold text-[#171522] text-lg">3. Gestione</h2><p>Puoi eliminare i cookie dal tuo browser in qualsiasi momento; la cancellazione del cookie di sessione equivale al logout.</p></section>
    </LegalShell>
  );
}
